import { PaymentMethod } from '@iota/iota-management-portal-v4-client';

export const PaymentMethods: string[] = [PaymentMethod.DEBIT, PaymentMethod.INVOICE];

export const PaymentMethodDescriptions = new Map([
    ['DEBIT', $localize`SEPA direct debit`],
    ['INVOICE', $localize`invoice`]
]);
